"use strict";
const _ = require('lodash');
const { zipToMapMap } = require('../../maps');
function getCustomerType(entity) {
    if (entity.supplier)
        return 'supplier';
    if (entity.deliveryCountry && entity.deliveryCountry !== 'SE')
        return 'export';
    return entity.customerType;
}
// invariants for the entity goes here
module.exports = entity => {
    const result = {
        ...entity,
        deliveryCounty: entity.deliveryZipCode
            ? zipToMapMap(entity.deliveryZipCode)
            : null,
        customerType: getCustomerType(entity),
    };
    const valuesToSetIfNull = {
        active: true,
        termsOfPayment: '10',
    };
    return _.merge({}, valuesToSetIfNull, result);
};
